export const pictureTypes = {
  harvest: "harvestPicture",
  flower: "flowerPicture",
};
